import {
	IAdditionalColumnsSubValue,
	ICheckoutEvolution,
	IFrequency,
	Map
} from '../../../typings/proto/protobufs';
import { FetchKey } from './MapView';

export interface MapData {
  initial?: boolean;
  events?: boolean;
  tags?: boolean;
  distribution?: boolean;
  checkouts?: boolean;
  additionalColumns?: boolean;
  additionalFields?: boolean;
  orders?: boolean;
  campaigns?: boolean;
  forms?: boolean[];
  frequencies?: boolean[];
  list: MapCompany[];
}

export interface MapCompany
  extends Map.ICampaignsMapRow,
    Map.IInitialMapRow,
    EventsMapRow,
    Map.ITagsMapRow,
    Map.IFormsMapRow,
    Map.IDistributionMapRow,
    Map.IOrdersMapRow,
    Map.ICheckoutRow,
    Map.IAdditionalColumnRow,
    Map.IAdditionalFieldRow {
  frequencies?: (IFrequency | null | undefined)[];
  formsRange?: number;
  // campaign pins: campaignId holds the ongoing pick, this one the upcoming
  // pick (soonest future period) — both chosen client-side per company
  futureCampaignId?: number;
}

export type FrequencyMapRow = {
  id?: number | null;
  frequency?: IFrequency | null;
};

export interface FormMapRow {
  id: number;
  lastFormDate: { seconds: number; nanos: number };
  formsRange: number;
}

export type EventsMapRow = Map.IEventsMapRow & {
  events: Array<[number, string | undefined, string | undefined]>;
  nextEvent: Array<[number, undefined, string]>;
  next?: boolean;
  range?: number;
  nextRange?: number;
};

export interface InitialMapRow {
  id: number;
  lat: number;
  lon: number;
  name: string;
  ownerId: number;
  clientStatusId: number;
  colorCode: string;
  city?: string;
  postCode?: string;
  country?: string;
}
export type Cluster = {
  id: number;
  properties: {
    cluster: true;
    cluster_id: number;
    details: ClusterProperties[];
    point_count: number;
    point_count_abbreviated: number;
  };
  geometry: {
    coordinates: [number, number];
  };
};

export function isCluster(cluster: Cluster | Point): cluster is Cluster {
	return cluster.properties.cluster;
}

export interface Point {
  properties: {
    cluster: false;
    id: number;
    color: string;
    detail: MapCompany;
  };
  geometry: {
    coordinates: [number, number];
  };
}

export interface ClusterProperties {
  // initial
  id: number | null | undefined;
  owner: number | null | undefined;
  status: number | null | undefined;
  statusColor: string | null | undefined;
  // events
  next?: boolean;
  range?: number;
  campaign?: number | null | undefined;
  futureCampaign?: number | null | undefined;
  nextRange?: number;
  // distribution
  distribution?: number[] | null;
  // orders
  orderRange?: number;
  // forms
  formsRange?: number;
  // frequency
  frequencies?: (IFrequency | null | undefined)[];
  checkouts?: ICheckoutEvolution | null | undefined;
  // additionalColumns
  additionalColumnsValue?: { [k: string]: IAdditionalColumnsSubValue } | null;
  additionalFieldColumnsValue?: {
    [k: string]: IAdditionalColumnsSubValue;
  } | null;
  calculatedFieldColumnsValue?: {
    [k: string]: IAdditionalColumnsSubValue;
  } | null;
}

export interface GooglePlaceItem {
  displayName: {
    languageCode: string;
    text: string;
  };
  formattedAddress?: string;
  location: {
    latitude: number;
    longitude: number;
  };
  id: string;
  nationalPhoneNumber?: string;
  addressComponents: {
    longText: string;
    shortText: string;
    types: string[];
  }[];
  websiteUri?: string;
}

export interface modalLeftState {
  tabType: FetchKey;
  rangeColor: {
    firstRange: number;
    lastRange: number;
  };
}
